import { getShippingAddress } from "@customer-app/utils/getDeliveryMethodTitle";
import { Stack, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import type { IMailingAddressJson } from "@smartrr/shared/entities/MailingAddress";
import type { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import { SubscriptionDeliveryMethod } from "@smartrr/shared/shopifyGraphQL/api";
import { formatAddressInline, formatGiftingAddressInline } from "@smartrr/shared/utils/formatAddressInline";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

export const OrderHistoryShippedTo = ({
  deliveryMethod,
  shippingAddress,
  subscription,
}: {
  subscription: IPurchaseState | undefined;
  shippingAddress: IMailingAddressJson | undefined;
  deliveryMethod: SubscriptionDeliveryMethod | undefined;
}) => {
  const gift = subscription?.gifts?.[0];
  const isGift = !!gift?.to;
  let deliveryAddress: string | undefined;

  if (gift) {
    deliveryAddress = formatGiftingAddressInline(gift.to);
  } else {
    deliveryAddress = formatAddressInline(shippingAddress);
  }

  if (!deliveryAddress) {
    deliveryAddress = getShippingAddress(shippingAddress, deliveryMethod, gift);
  }

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      className={prefixClassName(isGift ? "gifted-to-line" : "shipped-to-line")}
    >
      {isGift ? (
        <Typography variant="body2" whiteSpace="nowrap">
          {typedLocalize("orderHistory.giftedTo")}
        </Typography>
      ) : (
        <Typography variant="body2" whiteSpace="nowrap">
          {typedLocalize("orderHistory.shippedTo")}
        </Typography>
      )}
      <Typography variant="body1" sx={{ textAlign: "right" }}>
        {deliveryAddress}
      </Typography>
    </Stack>
  );
};
